import { gql } from '@apollo/client';

export const REQUEST_ADMIN_TOKEN = gql`
  mutation requestAdminToken($targetOrganizationId: Int!, $action: String, $reason: String, $identityOnBehalf: Int!) {
    AdminMutations {
      requestAdminToken(
        targetOrganizationId: $targetOrganizationId
        action: $action
        reason: $reason
        identityOnBehalf: $identityOnBehalf
      ) {
        userId
        adminToken {
          action
          tokenId
          expiry
        }
      }
    }
  }
`;

export const QUERY_GET_IDENTITIES_FOR_ORGANIZATION = gql`
  query getIdentitiesForOrganization($organizationId: Int!) {
    AdminQueries {
      getIdentitiesForOrganization(organizationId: $organizationId) {
        id
        firstName
        lastName
      }
    }
  }
`;
